import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faMoneyBillWave } from '@fortawesome/free-solid-svg-icons'
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'
import { faFileImport } from '@fortawesome/free-solid-svg-icons'
import { faFileExport } from '@fortawesome/free-solid-svg-icons'
import { faArchive } from '@fortawesome/free-solid-svg-icons'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
 
library.add(faCheck)
library.add(faEdit)
library.add(faTrash)
library.add(faArchive)
library.add(faEye)
library.add(faMoneyBillWave)
library.add(faFileInvoiceDollar)
library.add(faFileImport)
library.add(faFileExport)
 
Vue.component('font-awesome-icon', FontAwesomeIcon)

import Vue from 'vue'
import App from './App'

import './config/bootstrap'
import './config/axios'
import './config/msgs'
import './config/money'

import store from './config/store'
import router from './config/router'
import Vuelidate from './config/vuelidate'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  Vuelidate,
  render: h => h(App)
}).$mount('#app')